import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface TicketDrawerEmptyStateProps {
  description: string;
  title: string;
}

export default function TicketDrawerEmptyState({
  description,
  title,
}: TicketDrawerEmptyStateProps) {
  return (
    <Box
      data-test-id="ticket-drawer-empty-state"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        height: '100%',
        justifyContent: 'center',
        p: 4,
      }}
    >
      <RadioButtonUnchecked sx={{ color: 'divider', fontSize: 56 }} />

      <Typography variant="h6" sx={{ fontWeight: 600, textAlign: 'center' }}>
        {title}
      </Typography>

      <Typography
        variant="body1"
        sx={{ color: 'text.secondary', maxWidth: '320px', textAlign: 'center' }}
      >
        {description}
      </Typography>
    </Box>
  );
}
